import { useMemo } from "react";

export function Stardust({ count = 24, className = "" }) {
  const dots = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: `dust-${i}-${Math.round(Math.random() * 1e6)}`,
        left: Math.random() * 100,
        bottom: Math.random() * 30,
        size: 4 + Math.random() * 10,
        delay: Math.random() * 3,
        dur: 2.4 + Math.random() * 2.5,
      })),
    [count]
  );
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {dots.map((d) => (
        <span
          key={d.id}
          className="stardust"
          style={{
            left: `${d.left}%`,
            bottom: `${d.bottom}%`,
            width: d.size,
            height: d.size,
            animationDelay: `${d.delay}s`,
            animationDuration: `${d.dur}s`,
          }}
        />
      ))}
    </div>
  );
}
